<template>
    <hts-slide-over
        :show="show"
        :title="action === 'create' ? $t('labels.supplyPlugin.add') : $t('labels.supplyPlugin.edit')"
        :submit="onSubmit"
        :rules="rules"
        @close="close">
        <template #body>
            <div class="hts-vehicles-ignore-add-vehicle">
                <div class="hts-vehicles-ignore-add-vehicle__container-body">
                    <div
                        class="grid gap-4 p-4"
                        :class="columnClass">
                        <hts-form-input
                            v-model="dataForm.name"
                            :label="$t('labels.supplyPlugin.name')"
                            :color="props.color"
                            required
                            prop="name"
                            name="name" />
                        <hts-form-select
                            v-model="dataForm.status"
                            :label="$t('labels.supplyPlugin.status')"
                            :items="selectOptionStatus"
                            key-id="code"
                            key-label="name"
                            :color="props.color"
                            prop="status"
                            name="status" />
                        <hts-form-input
                            v-model="dataForm.description"
                            :label="$t('labels.supplyPlugin.description')"
                            :color="props.color"
                            prop="description"
                            name="description" />
                    </div>
                </div>
            </div>
        </template>
    </hts-slide-over>
</template>
<script lang="ts" setup>
import { ISupplyPlugin, ESupplyStatus } from '../models/supply'
const props = defineProps({
  show: {
    type: Boolean,
    default: false,
    required: true
  },
  column: {
    type: Number,
    default: 1
  },
  color: {
    type: String,
    default: 'theme'
  },
  pluginData: {
    type: Object as () => ISupplyPlugin,
    required: true
  },
  action: {
    type: String,
    default: 'create',
    required: true
  }
})

const emits = defineEmits(['close', 'on-submit'])

const dataForm: ISupplyPlugin = reactive({ ...props.pluginData })

const selectOptionStatus = [
  {
    code: ESupplyStatus.DEFAULT,
    name: $t('labels.supplyList.default')
  },
  {
    code: ESupplyStatus.INACTIVE,
    name: $t('labels.supplyList.inactive')
  },
  {
    code: ESupplyStatus.ACTIVE,
    name: $t('labels.supplyList.active')
  },
  {
    code: ESupplyStatus.DISABLE,
    name: $t('labels.supplyList.disable')
  }
]

const rules = {
  name: 'required'
}

const show = computed(() => {
  return props.show
})
const action = computed(() => {
  return props.action
})

const cleanData = (data: any) => {
  const temp = data
  if (action.value === 'create') {
    delete temp.ID
  }
  for (const propName in temp) {
    if (temp[propName] === '') {
      delete temp[propName]
    }
  }
  return temp
}

const onSubmit = () => {
  const data = cleanData(dataForm)
  emits('on-submit', data, props.action)
}

const close = () => {
  emits('close')
}

const columnClass = computed(() => {
  if ($lodash.inRange(props.column, 1, 12)) {
    return `grid-cols-${props.column}`
  }

  return 'grid-cols-1'
})
</script>
